import {
  CardBrandType,
  PaymentMethodType,
  PaymentMethodWalletType,
} from "@gymflow/types";
import { ReactNode } from "react";

import { PMAmexIcon } from "./atoms/icons/PMAmexIcon";
import { PMApplePayIcon } from "./atoms/icons/PMApplePayIcon";
import { PMBankIcon } from "./atoms/icons/PMBankIcon";
import { PMDirectDebitIcon } from "./atoms/icons/PMDirectDebitIcon";
import { PMGooglePayIcon } from "./atoms/icons/PMGooglePayIcon";
import { PMLinkIcon } from "./atoms/icons/PMLinkIcon";
import { PMMasterCardIcon } from "./atoms/icons/PMMasterCardIcon";
import { PMSepaIcon } from "./atoms/icons/PMSepaIcon";
import { PMUnknownCardBrandIcon } from "./atoms/icons/PMUnknownCardBrandIcon";
import { PMVisaIcon } from "./atoms/icons/PMVisaIcon";

export const WALLET_ICONS: Record<PaymentMethodWalletType, ReactNode> = {
  LINK: <PMLinkIcon />,
  APPLE_PAY: <PMApplePayIcon />,
  GOOGLE_PAY: <PMGooglePayIcon />,
  UNSUPPORTED: <PMUnknownCardBrandIcon />,
};

export const PAYMENT_METHOD_TYPE_ICONS: Record<PaymentMethodType, ReactNode> = {
  LINK: <PMLinkIcon />,
  UK_DIRECT_DEBIT: <PMDirectDebitIcon />,
  AU_DIRECT_DEBIT: <PMDirectDebitIcon />,
  EU_DIRECT_DEBIT: <PMSepaIcon />,
  US_DIRECT_DEBIT: <PMBankIcon />,
  CA_DIRECT_DEBIT: <PMBankIcon />,
  CARD: <PMUnknownCardBrandIcon />,
  UNSUPPORTED: <PMUnknownCardBrandIcon />,
};

export const CARD_BRAND_ICONS: Record<CardBrandType, ReactNode> = {
  mastercard: <PMMasterCardIcon />,
  visa: <PMVisaIcon />,
  amex: <PMAmexIcon />,
  diners: <PMUnknownCardBrandIcon />,
  discover: <PMUnknownCardBrandIcon />,
  eftpos_au: <PMUnknownCardBrandIcon />,
  jcb: <PMUnknownCardBrandIcon />,
  unionpay: <PMUnknownCardBrandIcon />,
  unknown: <PMUnknownCardBrandIcon />,
};
